import { useSelector } from 'react-redux';

import { select } from '@swf/core/store';

const useMitIdDataContext = (path: string) => {
  const pathName = useSelector(select.location.getPathname);
  const query = useSelector(select.location.getQuery);
  return !!pathName && pathName.includes(path) && !!query?.mitid;
};

export default useMitIdDataContext;
